// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import ListItem from '@mui/material/ListItem';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { styled } from '@mui/system';

// Section for import custom types -------------------------------------------------------------------------------------
import PrefecturesData from '@/types/components/MansionNavigation/PrefecturesData';

import Regions from '@/config/data/regionItems.json';

interface PrefecturesListProps {
  prefecturesData: PrefecturesData;
  expanded: string | false;
  postfixLinkText: string;
  accordionChange: (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => void;
}

const StyledAccordionSummary = styled(AccordionSummary)({
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid gray',
  '& .MuiAccordionSummary-expandIcon': {
    order: -1,
    color: 'black',
  },
  '& .Mui-expanded': {
    margin: '12px 0 !important',
  },
});

// Section for render component ----------------------------------------------------------------------------------------
export default function PrefecturesListSp({
  prefecturesData,
  expanded,
  postfixLinkText,
  accordionChange,
}: PrefecturesListProps): React.JSX.Element {
  return (
    <Box>
      {Regions.map((region) => (
        <Accordion
          key={region.sort_id}
          style={{
            backgroundColor: 'transparent',
            color: '#191919',
          }}
          elevation={0}
          expanded={expanded === `panel-${region.sort_id}`}
          onChange={accordionChange(`panel-${region.sort_id}`)}
          className="my-0"
          sx={{
            '&.Mui-expanded': {
              '&::before': {
                opacity: 1,
              },
            },
          }}
        >
          <StyledAccordionSummary
            expandIcon={
              <KeyboardArrowDownRoundedIcon
                sx={{
                  color: '#191919',
                }}
              />
            }
            className="min-h-fit h-[57px]  py-1"
            sx={{
              borderBottom: 'none',
              '&.Mui-expanded': {
                borderBottom: 'none',
              },
            }}
          >
            <Typography className="text-sm font-bold" style={{ flexGrow: 1 }}>
              {region.region_name}
            </Typography>
          </StyledAccordionSummary>
          <AccordionDetails
            className="flex flex-col pl-8 py-0 pr-0"
            sx={{
              borderTop: 'none',
              borderBottom: 'none',
            }}
          >
            {prefecturesData
              .filter((prefectureData) => prefectureData.region_id === region.region_id)
              .map((prefecture, index) => (
                <ListItem
                  key={`prefecture-${region.sort_id}-${prefecture.id}`}
                  className="border-b-[1px] last:border-b-0 border-gray-02 mt-0 pl-0 py-4 pr-4 first:py-0 first:pb-4 last:py-0 last:pt-4 last:pb-5 pr-0"
                >
                  <Typography className="w-full text-sm font-bold rf-hover-text">
                    <Link
                      href={`/karte/${prefecture.pref_code_name}${postfixLinkText}`}
                      underline="none"
                      className="flex justify-between w-full text-rf-black leading-6"
                    >
                      {prefecture.pref_name}
                    </Link>
                  </Typography>
                </ListItem>
              ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}
